import { useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { IValueListLight } from '../../../../types/valuelist'
import { CancelIcon, CheckIcon } from '../../../common/icons'
import Select from '../../../common/select/select'
import { IIndividual } from '../../../../types/individual'
import { fullNameAutoFormat } from '../../../../utils/format-fullname'
import Button from '../../../common/button'

type  DeactivateAssignmentDialogProg={
    onConfirm : (reasonId?:number)=>void,
    isOpen: boolean,
    toggle: ()=>void,
    reasonList:IValueListLight[],
    individual:IIndividual,
    fullPositionName:string
}

const DeactivateAssignmentModal = (props: DeactivateAssignmentDialogProg) => {
    const {onConfirm,isOpen,toggle,reasonList,individual,fullPositionName } = props

    const [reasonId,setReasonId] = useState<number>(0)

    const onClickHide = () => {
        toggle()
    }

    const onClickOk = () => {

        onConfirm(reasonId)
        toggle()
        setReasonId(0)
    }

    const onChangeHandler = (event:any)=>{
        if(event.target.value)
            setReasonId(event.target.value)
        else
            setReasonId(0)
    }

    return <div className='confirm'>
         <Modal role="alertdialog" style={{maxWidth: '600px'}} isOpen={isOpen} toggle={toggle} backdrop="static" autoFocus={false}>
            <ModalHeader toggle={toggle} tag={'h2'}>Deactivate Assignment</ModalHeader>
            <ModalBody>
                <p className='mb-0'><strong>{fullNameAutoFormat(individual.firstName,individual.middleName,individual.lastName)}'s</strong> home position <i><strong>({fullPositionName})</strong></i> will be deactivated.</p>
                <p className='mb-0'>Please provide a reason for this action.</p>
                <label htmlFor ="reason" >Deactivation Reason: (required)</label>
                <Select id="reason" value={reasonId}  onChange={onChangeHandler} style={{width:'100%'}} autoFocus={true}>
                    <option value="0" disabled hidden>Select a reason for deactivating this assignment</option>
                    <option value=""></option>
                    {reasonList?.map((item: IValueListLight) => <option key={item.id} value={item.id}>{item.label}</option>)}
                </Select>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={onClickOk} disabled={!reasonId||reasonId===0}>
                    <CheckIcon /> Confirm
                </Button>
                <Button color="secondary" onClick={onClickHide}>
                    <CancelIcon /> Cancel
                </Button>
            </ModalFooter>
        </Modal>
    </div>
}

export default DeactivateAssignmentModal;
